<template>
  <li
    class="dropdown-menu-item"
    :class="{ 'dropdown-menu-item_compact': compact }"
    @click.stop="handleClick"
  >
    <slot />

    <Icon
      v-if="hasSubMenu"
      class="dropdown-submenu-chevron"
      type="chevron-right"
    />

    <ul
      v-if="hasSubMenu"
      v-show="isSubMenuOpen"
      class="dropdown-menu dropdown-menu-submenu"
    >
      <slot name="submenu"></slot>
    </ul>
  </li>
</template>

<script setup>
import { inject, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import Icon from '@/components/icon/Icon.vue'

const props = defineProps({
  route: {
    type: String,
    default: null
  },
  link: {
    type: String,
    default: null
  },
  closeOnClick: {
    type: Boolean,
    default: true
  },
  hasSubMenu: {
    type: Boolean,
    default: false
  },
  onClick: {
    type: Function,
    default: () => {}
  },
  compact: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['itemClicked'])
const router = useRouter()
const dropdownIsOpen = inject('isOpen')
const closeDropdown = inject('closeDropdown')

const isSubMenuOpen = ref(true)

watch(
  dropdownIsOpen,
  (oldVal, newVal) => {
    // console.log('change from: ' + oldVal + ' to:' + newVal)
    if (!newVal) {
      isSubMenuOpen.value = false
    }
  },
  { immediate: true }
)

const handleClick = () => {
  emit('itemClicked')

  if (props.hasSubMenu) {
    isSubMenuOpen.value = !isSubMenuOpen.value
  } else {
    if (props.link) {
      window.location = props.link
    } else if (props.route) {
      router.push(props.route)
    } else {
      props.onClick()
    }
    if (props.closeOnClick) {
      closeDropdown()
    }
  }
}
</script>

<style>
.dropdown-menu-item {
  /* margin: 0px 6px; */
  padding: var(--s-1-5) 0.625rem;
  clear: both;
  text-align: inherit;
  background-color: transparent;
  /* background-color: grey; */
  border-radius: var(--rounded-md);
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* width: 100%; */
  font-weight: 400;
  white-space: nowrap;
  position: relative;
}

.dropdown-menu-item_compact {
  padding: 0.2rem 0.425rem;
  margin: 0;
}

.dropdown-menu-item:hover {
  background-color: var(--bg-primary_hover);
  cursor: pointer;
}

.dropdown-menu-item > .icon:not(.dropdown-submenu-chevron) {
  margin-right: var(--s-3);
}

.dropdown-menu-submenu {
  /* display: none; */
  padding: var(--s-2) 0;
  margin: 0px 6px;
  position: absolute;
  left: 100%;
  top: 0;
  min-width: 160px;
}
</style>
